import { injectable } from 'inversify';
import type { HttpResponse, IHttpInterceptor } from './modules/http';
import { config } from '@/config/app.config';

@injectable()
export class AuthInterceptor implements IHttpInterceptor<HttpResponse> {
  public async onRejected(err: unknown): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    if ((err as any)?.response?.status === 401) {
      const returnUrl = encodeURIComponent(window.location.href);
      window.location.assign(config.mip.authorizeURL + returnUrl);
      throw err;
    } else {
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      return Promise.reject(err);
    }
  }
}
